import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportPath extends Schema {
    @type(["number"])
    @defaultValue([])
    points: number[];
    @type("number")
    @defaultValue(0)
    cursor: number;
    @type("number")
    @defaultValue(0)
    targetX: number;
    @type("number")
    @defaultValue(0)
    targetY: number;
    @type("boolean")
    @defaultValue(false)
    moving: boolean;
    @type("number")
    @defaultValue(2.7)
    speed: number;
    @type("number")
    @defaultValue(0)
    stuck: number;
    @type("number")
    @defaultValue(0)
    lastX: number;
    @type("number")
    @defaultValue(0)
    lastY: number;
    @type("number")
    @defaultValue(0)
    revision: number;
}
